import { datadogLogs } from "@datadog/browser-logs";
import { ethers } from "ethers";
import React, { createContext, useContext, useState } from "react";
import { ProgressStatus } from "../../api/types";
import { getAddress } from "viem";
import { jsx as _jsx } from "react/jsx-runtime";
export const DirectAllocationProvider = _ref => {
  let {
    children
  } = _ref;
  const [tokenApprovalStatus, setTokenApprovalStatus] = useState(initialDirectAllocationState.tokenApprovalStatus);
  const [fundStatus, setFundStatus] = useState(initialDirectAllocationState.fundStatus);
  const [indexingStatus, setIndexingStatus] = useState(initialDirectAllocationState.indexingStatus);
  const [txHash, setTxHash] = useState(initialDirectAllocationState.txHash);
  const [txBlockNumber, setTxBlockNumber] = useState(initialDirectAllocationState.txBlockNumber);
  const providerProps = {
    tokenApprovalStatus,
    setTokenApprovalStatus,
    fundStatus,
    setFundStatus,
    indexingStatus,
    setIndexingStatus,
    txHash,
    setTxHash,
    txBlockNumber,
    setTxBlockNumber
  };
  return /*#__PURE__*/_jsx(DirectAllocationContext.Provider, {
    value: providerProps,
    children: children
  });
};
export const initialDirectAllocationState = {
  tokenApprovalStatus: ProgressStatus.NOT_STARTED,
  setTokenApprovalStatus: () => {
    /**/
  },
  fundStatus: ProgressStatus.NOT_STARTED,
  setFundStatus: () => {
    /**/
  },
  indexingStatus: ProgressStatus.NOT_STARTED,
  setIndexingStatus: () => {
    /**/
  },
  txHash: "",
  setTxHash: () => {
    /**/
  },
  txBlockNumber: -1,
  setTxBlockNumber: () => {
    /**/
  }
};
export const DirectAllocationContext = /*#__PURE__*/createContext(initialDirectAllocationState);
export const useDirectAllocation = () => {
  const context = useContext(DirectAllocationContext);
  if (context === undefined) {
    throw new Error("useDirectAllocation must be used within a DirectAllocationProvider");
  }
  const handleDirectAllocation = async params => {
    return _directAllocation({
      ...params,
      context
    });
  };
  return {
    directAllocation: handleDirectAllocation,
    tokenApprovalStatus: context.tokenApprovalStatus,
    fundStatus: context.fundStatus,
    indexingStatus: context.indexingStatus,
    txHash: context.txHash,
    txBlockNumber: context.txBlockNumber
  };
};
function resetToInitialState(context) {
  const {
    setTokenApprovalStatus,
    setFundStatus,
    setIndexingStatus,
    setTxHash,
    setTxBlockNumber
  } = context;
  setTokenApprovalStatus(initialDirectAllocationState.tokenApprovalStatus);
  setFundStatus(initialDirectAllocationState.fundStatus);
  setIndexingStatus(initialDirectAllocationState.indexingStatus);
  setTxHash(initialDirectAllocationState.txHash);
  setTxBlockNumber(initialDirectAllocationState.txBlockNumber);
}
async function _directAllocation(_ref2) {
  let {
    allo,
    context,
    poolId,
    fundAmount,
    payoutToken,
    recipient,
    nonce,
    requireTokenApproval
  } = _ref2;
  resetToInitialState(context);
  try {
    const amount = ethers.utils.parseUnits(fundAmount.toString(), payoutToken.decimals).toBigInt();
    const recipientAddress = getAddress(recipient);
    context.setTokenApprovalStatus(ProgressStatus.IN_PROGRESS);
    const result = await allo.directAllocation({
      poolId,
      tokenAddress: payoutToken.address,
      amount,
      recipient: recipientAddress,
      nonce,
      requireTokenApproval
    }).on("tokenApprovalStatus", tx => {
      if (tx.type === "error") {
        context.setTokenApprovalStatus(ProgressStatus.IS_ERROR);
      } else {
        context.setTokenApprovalStatus(ProgressStatus.IS_SUCCESS);
        context.setFundStatus(ProgressStatus.IN_PROGRESS);
      }
    }).on("transaction", tx => {
      if (tx.type === "error") {
        context.setFundStatus(ProgressStatus.IS_ERROR);
      }
    }).on("transactionStatus", tx => {
      if (tx.type === "error") {
        context.setFundStatus(ProgressStatus.IS_ERROR);
      } else {
        context.setFundStatus(ProgressStatus.IS_SUCCESS);
        context.setTxHash(tx.value.transactionHash);
        context.setTxBlockNumber(Number(tx.value.blockNumber));
        context.setIndexingStatus(ProgressStatus.IN_PROGRESS);
      }
    }).execute();
    if (result.type === "error") {
      throw result.error;
    }
  } catch (error) {
    datadogLogs.logger.error(`error: _directAllocation - ${error}`);
    console.error("Error while donating: ", error);
  }
}